import { InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { ErrorWrapper } from '../ErrorWrapper';

interface IGeoEmptyErrorProps {
  onAddGeoClick(): void;
}

export const GeoEmptyError = ({ onAddGeoClick }: IGeoEmptyErrorProps) => {
  return (
    <ErrorWrapper>
      <InlineText2 textAlign="center">
        Добавьте адрес, чтобы <br /> увидеть конкуренцию
      </InlineText2>

      <LinkButton marginTop={8} onClick={onAddGeoClick}>
        Добавить адрес
      </LinkButton>
    </ErrorWrapper>
  );
};
